export default __webpack_public_path__ + "static/media/page-facing-up.ffe917bd.png";